import styled from '@emotion/styled';

export default styled;

export type ThemeType = 'light' | 'dark';
